import React from "react";
import { ReactSortable, Sortable, MultiDrag } from "react-sortablejs";
import Dropzone from "dropzone";
import Cx from "classnames";

import { instantSave } from "../../helpers.js";
import styles from "./styles.scss";
import ImageActions from "./ImageActions";
import ArchivedImageActions from "./ImageActions/archivedImageActions";
import PrimaryImage from "./PrimaryImage";
import { PlusIcon } from "./PlusIcon/index.jsx";

Dropzone.autoDiscover = false;

Sortable.mount(new MultiDrag());

const humanFileSize = (bytes, si = true, dp = 1) => {
  const thresh = 1000;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
};

export default class ImageUploader extends React.Component {
  state = {
    items: [],
    itemsUndo: [],
    archivedItems: [],
    isFullscreen: false,
    zoom: 1,
  };

  handleDrop = (acceptedFiles) => {
    console.log(acceptedFiles);
  };

  handleZoomIn = () => {
    let zoom = this.state.zoom;
    if (this.state.zoom !== 0) zoom--;

    this.setState({ zoom });
  };

  handleZoomOut = () => {
    let zoom = this.state.zoom;
    if (this.state.zoom < 3) zoom++;

    this.setState({ zoom });
  };

  undo = () => {
    const { itemsUndo, archivedItemsUndo } = this.state;
    this.setState({
      items: itemsUndo,
      archivedItems: archivedItemsUndo,
    });
  };

  updateArchivedFilesVal = () => {
    const { archivedItems } = this.state;
    const archivedField = $(".files_archived").val();
    let archivedFiles = archivedField.length
      ? JSON.parse(archivedField)
      : { image: [] };
    archivedFiles["image"] = archivedFiles["image"] || [];
    archivedFiles["image"] = archivedItems.map((i) => i.id);

    $(".files_archived").val(JSON.stringify(archivedFiles));
  };

  handleAddedFile = (file) => {
    if (this.props.maxFiles && this.state.items.length >= this.props.maxFiles) {
      alert(`You can upload a maximum of ${this.props.maxFiles} files here.`);
    } else {
      let dz = this._dz;
      console.log("added");
      console.log(file);

      const newItem = {
        status: "added",
        filename: file.name,
        size: file.size,
        uuid: file.upload.uuid,
      };

      this.setState({
        items: this.state.items.concat(newItem),
      });

      const options = {
        filename: file.name,
        type: file.type,
        _: Date.now(),
      };

      $.ajax({
        url: "/presign_b2",
        data: options,
        type: "GET",
        // async: false,
        success: (response) => {
          console.log("response test", response);

          file.dynamicUrl = response["url"];
          // dz.options.url = response['url'];
          dz.enqueueFile(file);
        },
      });
    }
  };

  handleSending = (file, xhr) => {
    console.log("file sending", file);
    const { name, dynamicUrl } = file;
    // non-ASCII characters in filename must be encoded
    // https://stackoverflow.com/a/64317676/8749164
    const filename = encodeURIComponent(name.replace("'", "`")).replace(
      /[!'()*]/g,
      (c) => {
        return "%" + c.charCodeAt(0).toString(16);
      }
    );

    xhr.open("PUT", dynamicUrl);
    // xhr.setRequestHeader(
    //   "Content-Disposition",
    //   `inline; filename="${filename}"`
    // );
    let _send = xhr.send;
    xhr.send = function () {
      _send.call(xhr, file);
    };

    const items = this.state.items.map((item) => {
      if (item.uuid === file.upload.uuid)
        return {
          ...item,
          status: "uploading",
        };
      return item;
    });

    this.setState({ items });
  };

  handleUploadprogress = (data) => {
    const items = this.state.items.map((item) => {
      if (item.uuid === data.upload.uuid)
        return {
          ...item,
          progress: data.upload.progress,
        };
      return item;
    });

    this.setState({ items });
  };

  handleError = (data, response) => {
    console.log("data error", data);
    console.log("response error", response);

    const status_code =
      typeof response.status !== "undefined" ? response.status : "";

    console.log("status_code", status_code);

    this._dz.processQueue();

    window.unsavedChanges(false);

    const items = this.state.items.map((item) => {
      if (item.uuid === data.upload.uuid)
        return {
          ...item,
          status: "error",
          filename: response,
          progress: null,
        };
      return item;
    });

    this.setState({ items });
  };

  handleSuccess = (data) => {
    console.log("data", data);
    let dz = this._dz;
    const image = {
      id: data.upload.filename,
      storage: "cache",
      metadata: {
        size: data.size,
        filename: data.name,
        mime_type: data.type,
      },
    };
    console.log(image);
    console.log(data.previewElement);
    console.log("success data", data);

    let that = this;
    // After a file is successfully uploaded, we need to send it back
    // to Rails so that it can be attached to the Image model
    $.ajax("/images", {
      method: "POST",
      data: { image: { imagefile: JSON.stringify(image) } },
    }).done((response) => {
      console.log("response images POST", response);

      dz.processQueue();

      const items = that.state.items.map((item) => {
        if (item.uuid === data.upload.uuid)
          return {
            ...response,
            status: "success",
            progress: 0,
          };
        return item;
      });

      console.log("items success", items);

      that.setState({ items });
    });
  };

  pollServer = () => {
    // check repeatedly to see if the images have finished processing
    let that = this;

    setInterval(() => {
      let items = that.state.items.filter(
        (item) =>
          item.status !== "processed" && item.status !== "error" && item.id
      );

      // approx one in 5 times, check all the images, otherwise
      // just check the first 5 images
      // this is to avoid making a lot of requests
      // TODO - create an endpoint that polls multiple image ids at the same time
      if (_.random(4) !== 4) items = items.slice(0, 5);

      items.forEach((item) => {
        $.getJSON(`/images/${item.id}/show`, (response) => {
          if (!response.thumb.includes("delayed_processing.png")) {
            console.log('hello????', )
            const items = that.state.items.map((x) => {
              if (x.id === response.id) {
                return {
                  ...response,
                  status: "processed",
                };
              }
              return x;
            });

            that.setState({ items });
          } else {
            console.log(response.id + " is not finished");
          }
        });
      });
    }, 1500);
  };

  handleImageAction = (items, archivedItems) => {
    // pass state up from ImageAction component to ImageUploader
    this.setState({ items, archivedItems });
  };

  handleToggleFullscreen = (x) => {
    let isFullscreen;
    // can handle taking params or just toggling
    if (typeof x === "boolean") {
      isFullscreen = !!x;
    } else {
      isFullscreen = !this.state.isFullscreen;
    }

    // prevent scrolling  https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
    if (isFullscreen && this.state.isFullscreen === false) {
      const scrollY =
        document.documentElement.style.getPropertyValue("--scroll-y");
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
    } else if (!isFullscreen && this.state.isFullscreen === true) {
      const scrollY =
        document.documentElement.style.getPropertyValue("--scroll-y");
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, scrollY);
    }

    this.setState({ isFullscreen });
  };

  updateScrollPosition = () => {
    // this is so that when you clock the fullscreen mode, the user returns their original scroll position
    if (window.scrollY)
      document.documentElement.style.setProperty("--scroll-y", window.scrollY);
  };

  handleClickArchivedItem = (e, itemId) => {
    const archivedItems = this.state.archivedItems.map((i) => {
      let item = i;
      if (item.id === itemId) item.selected = !item.selected;

      return item;
    });

    this.setState({ archivedItems });
  };

  componentDidUpdate(prevProps, prevState) {
    // if primary_image field has not been set, or primary image has been deleted in
    // the "Image Files" panel, then assign the first image to be the primary image
    let items = this.state.items;
    if (items.length && !items.filter((i) => i.isPrimary).length) {
      const first = items[0];
      items[0] = {
        ...items[0],
        isPrimary: true,
      };

      this.setState({ items });
    }

    // if the image IDs have changed then save
    if (
      prevState.items.map((i) => i.id).toString() !==
      this.state.items.map((i) => i.id).toString()
    ) {
      // prevent scenario where undo button deletes all the images right after component mounts
      const itemsUndo = prevState.items.length
        ? prevState.items
        : this.state.items;
      const archivedItemsUndo = prevState.archivedItems.length
        ? prevState.archivedItems
        : this.state.archivedItems;

      this.setState({ itemsUndo, archivedItemsUndo });
      this.updateArchivedFilesVal();
      instantSave();
    }
  }

  componentDidMount() {
    this._dz = new Dropzone(this._el, {
      url: "#",
      method: "PUT",
      paramName: "file",
      maxFiles: 800, // doesnt seem to work
      maxFilesize: 4000,
      timeout: 300000, // 5 minutes in milliseconds
      acceptedFiles:
        "image/jpeg, image/png, image/tiff, image/gif, application/pdf",
      autoProcessQueue: true,
      autoQueue: false,
      createImageThumbnails: false,
      parallelUploads: 3,
      previewTemplate: "<div></div>", // handle all rendering in React
      clickable: "#image-dropzone-upload-button",
    });

    this._dz.on("addedfile", this.handleAddedFile);
    this._dz.on("sending", this.handleSending);
    this._dz.on("success", this.handleSuccess);
    this._dz.on("uploadprogress", this.handleUploadprogress);
    this._dz.on("error", this.handleError);

    const bodyEl = document.querySelector("body");
    bodyEl.addEventListener("globalDrop", (e) => {
      const allFiles = e.detail;
      const imageFiles = "image/jpeg, image/png, image/tiff, image/gif";
      const files = allFiles.filter(
        (file) => file.type && imageFiles.includes(file.type)
      );

      this._dz.drop({ dataTransfer: { files } });
    });

    window.addEventListener(
      "scroll",
      _.throttle(this.updateScrollPosition, 100)
    );

    // load pre-existing images into the component
    if (this.props.itemData) {
      this.setState({
        items: this.props.itemData,
        itemsUndo: this.props.itemData,
      });
    }

    if (this.props.archivedItemData) {
      this.setState({ archivedItems: this.props.archivedItemData });
    }

    this.pollServer();
  }

  render() {
    const { recordType, recordId, imageCreditElement, averageImageSize } = this.props;
    const { items, archivedItems, isFullscreen } = this.state;
    const item_list = items
      .map((item) => item.id)
      .filter((i) => !!i)
      .join(",");
    const primary_image = items ? items.filter((i) => i.isPrimary)[0] : null;
    // const archived_items

    // this.updateArchivedFilesHiddenInput();

    return (
      <>
        <div
          ref={(c) => {
            this._uploader = c;
          }}
          className={Cx(
            { [styles.dragging]: this.state.isDraggingOver },
            { [styles.isFullscreen]: this.state.isFullscreen },
            styles[`zoom${this.state.zoom}`]
          )}
        >
          <PrimaryImage
            item={primary_image}
            items={this.state.items}
            recordType={recordType}
          />
          <input
            className="image_list"
            name={`${recordType}[image_list]`}
            id={`${recordType}_image_list`}
            type="hidden"
            value={item_list}
          />

          <div
            dangerouslySetInnerHTML={{
              __html: imageCreditElement.replace(/º/g, '"').replace(/\n/g, ""),
            }}
          />

          <div
            id="imageDrop"
            className={styles.items}
            ref={(c) => {
              this._items = c;
            }}
          >
            {!!items.length && (
              <ReactSortable
                list={items}
                setList={(newState) => {
                  this.setState({ items: newState });
                }}
                animation={150}
                multiDrag
                filter={`.${styles.error}`}
              >
                {items.map((item, index) => (
                  <div
                    className={Cx(
                      styles.item,
                      styles[item.status],
                      { [styles.isPrimary]: item.isPrimary },
                      { [styles.isWorkImage]: item.isWorkImage }
                    )}
                    key={item.uuid || item.id}
                  >
                    <div className={styles.image}>
                      <img src={item.thumb} />
                    </div>

                    <div className={styles.details}>
                      <div className={styles.filename}>
                        <span className={styles.filenameArea}>
                          <span>{item.filename}</span> (
                          <span>{humanFileSize(item.size)}</span>)
                        </span>
                      </div>
                    </div>

                    {!!item.progress && (
                      <div
                        className={styles.progress}
                        style={{ width: `${item.progress}%` }}
                      />
                    )}
                  </div>
                ))}
              </ReactSortable>
            )}
          </div>

          <div
            className={styles.dropzoneObject}
            ref={(c) => {
              this._el = c;
            }}
          />

          <div
            className={styles.dropzoneClickable}
            id="image-dropzone-upload-button"
          >
            <PlusIcon />
          </div>

          <ImageActions
            items={items}
            archivedItems={archivedItems}
            onImageAction={this.handleImageAction}
            onToggleFullscreen={this.handleToggleFullscreen}
            onZoomIn={this.handleZoomIn}
            onZoomOut={this.handleZoomOut}
            onUndo={this.undo}
            uploaderRef={this._uploader}
            isFullscreen={isFullscreen}
            recordType={recordType}
            recordId={recordId}
          />
        </div>

        <div
          className="panel file image-panel closed"
          style={{ display: archivedItems.length ? "block" : "none" }}
          ref={(c) => {
            this._archivedItems = c;
          }}
        >
          <div className="panel-title">Archived Images</div>
          <div className={styles.archivedItems}>
            <div>
              {archivedItems.map((item, index) => (
                <div
                  className={Cx(styles.item, {
                    [styles.archivedItemSelected]: item.selected,
                  })}
                  key={item.id}
                  onClick={(e) => this.handleClickArchivedItem(e, item.id)}
                >
                  <div className={styles.image}>
                    <img src={item.thumb} />
                  </div>

                  <div className={styles.details}>
                    <div className={styles.filename}>
                      <span className={styles.filenameArea}>
                        <span>{item.filename}</span> (
                        <span>{humanFileSize(item.size)}</span>)
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {averageImageSize && (
          <p
            className={styles.averageImageSize}
            dangerouslySetInnerHTML={{
              __html: `<b>Average image size:</b> ${averageImageSize}`
            }}
          />
        )}

        <ArchivedImageActions
          items={items}
          archivedItems={archivedItems}
          onImageAction={this.handleImageAction}
          archivedItemsRef={this._archivedItems}
        />
      </>
    );
  }
}
